import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { init, BrowserTracing } from '@sentry/browser';
import { isExpectedSignalRError, SIGNALR_TIMEOUT_MESSAGE } from '@/lib/signalr';
import './polyfill';
import { AppProvider } from './providers/app';

init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  ignoreErrors: [SIGNALR_TIMEOUT_MESSAGE],
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: [/^http:\/\/signage-app-display.s3-website.eu-north-1.amazonaws.\.com/],
    }),
  ],
  beforeSend(event, hint) {
    if (
      isExpectedSignalRError(hint.originalException) ||
      isExpectedSignalRError(hint.syntheticException) ||
      event.exception?.values?.some(v => isExpectedSignalRError(v?.value))
    ) {
      return null;
    }

    return event;
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);
